import { getUniqueSymbols } from '@/entities/symbol';
import { getSymbolsFromRows } from '@/features/markets/components/lib/getSymbolsFromRows';
import type { MiniTableBodyRow, MiniTableType } from '@/features/markets/types';

function getBodyRows(table: MiniTableType): MiniTableBodyRow[] {
  return table.rows.filter((row): row is MiniTableBodyRow => 'symbol' in row);
}

export function getMiniTableSymbols(table: MiniTableType) {
  return getUniqueSymbols(getSymbolsFromRows(getBodyRows(table)));
}

export function getAllMiniTableSymbols(tables: MiniTableType[]) {
  return tables.flatMap(getMiniTableSymbols);
}
